import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { get } from "lodash";

function AddAnimator(props) {
    const navigate = useHistory();
    const [formData, setName] = useState({
        AnimatorName: "",
        PrefabName: "",
        PrefabURL: "",
    });

    const [AnimatorImgPreview, setAnimatorImgPreview] = useState("");
    const [AnimatorImage, setAnimatorImage] = useState();

    const AddAnimatorSubmit = async (e) => {
        e.preventDefault();
        let formDataSet = new FormData();
        if (formData.AnimatorName === "" || formData.PrefabName === "" || formData.PrefabURL === "" || !AnimatorImage) {
            if (formData.AnimatorName === "") {
                Swal.fire({
                    title: "Error",
                    text: "Animator Name is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }

            if (formData.PrefabName === "") {
                Swal.fire({
                    title: "Error",
                    text: "Animator Prefab Name is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }

            if (formData.PrefabURL === "") {
                Swal.fire({
                    title: "Error",
                    text: "Animator Prefab URL is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }

            if (!AnimatorImage) {
                Swal.fire({
                    title: "Error",
                    text: "Animator Image is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        } else {
            formDataSet.append("Animator_Name", formData.AnimatorName);
            formDataSet.append("Animator_Prefab_Name", formData.PrefabName);
            formDataSet.append("Animator_URL", formData.PrefabURL);
            formDataSet.append("AnimatorImage", AnimatorImage);

            // Extract token from localStorage.state
            let token = null;
            try {
                const raw = localStorage.getItem("state");
                if (raw) {
                    const state = JSON.parse(raw);
                    token = state.auth?.token;
                }
            } catch (e) {
                console.error("Token parsing failed", e);
            }

            var authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/AddAnimator`,
                data: formDataSet,
                headers: { "content-type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
            };
            axios(authOptions)
                .then((res) => {
                    if (res.data.ExpResult) {
                        Swal.fire({
                            title: "Failed",
                            text: res.data.ExpResult,
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    } else if (res.data.SuccessResult) {
                        Swal.fire({
                            title: "Success",
                            text: res.data.SuccessResult,
                            icon: "success",
                            confirmButtonText: "Ok",
                        }).then(function () {
                            navigate.push("/AnimatorList")
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: "An error occured!",
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        title: "Error Occured",
                        text: "Something went wrong!",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                });
        }
    };

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };

    const handleAnimatorImgChange = (e) => {
        setAnimatorImage(get(e, "target.files[0]"));
        setAnimatorImgPreview(URL.createObjectURL(e.target.files[0]));
    }

    /* Function to redirect in Animator List Page */
    const BackFunc = () => {
        navigate.push("/AnimatorList")
    };

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title my-0">Add Animator</div>
                            </div>
                            <div className=" pull-right">
                                <button
                                    type="submit"
                                    className="btn d-inline-block btn-primary"
                                    onClick={BackFunc}
                                >
                                    {" "}
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-2 col-sm-2"></div>
                        <div className="col-md-8 col-sm-8">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>Add Animator</header>
                                </div>
                                <div className="card-body " id="bar-parent1">
                                    <form
                                        className="register-form"
                                        id="login-form"
                                        onSubmit={AddAnimatorSubmit}
                                    >

                                        {/* Animator Name */}
                                        <div className="form-group row required">
                                            <label
                                                htmlFor="AnimatorName"
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                                Animator Name
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    value={formData.AnimatorName}
                                                    onChange={handleChange}
                                                    name="AnimatorName"
                                                    className="form-control"
                                                    id="AnimatorName"
                                                    placeholder="Animator Name"
                                                />
                                            </div>
                                        </div>

                                        {/* Animator Prefab Name */}
                                        <div className="form-group row required">
                                            <label
                                                htmlFor="PrefabName"
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                                Prefab Name
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    value={formData.PrefabName}
                                                    onChange={handleChange}
                                                    name="PrefabName"
                                                    className="form-control"
                                                    id="PrefabName"
                                                    placeholder="Prefab Name"
                                                />
                                            </div>
                                        </div>

                                        {/* Animator Prefab URL */}
                                        <div className="form-group row required">
                                            <label
                                                htmlFor="PrefabURL"
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                                Prefab URL
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    value={formData.PrefabURL}
                                                    onChange={handleChange}
                                                    name="PrefabURL"
                                                    className="form-control"
                                                    id="PrefabURL"
                                                    placeholder="Prefab URL"
                                                />
                                            </div>
                                        </div>

                                        {/* Animator Image */}
                                        <div className="form-group row required">
                                            <label
                                                htmlFor="AnimatorImg"
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                                Animator Image
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="file"
                                                    name="AnimatorImg"
                                                    onChange={handleAnimatorImgChange}
                                                    className="form-control"
                                                    accept="image/*"
                                                    style={{ "lineHeight": "1.8" }}
                                                    id="AnimatorImg"
                                                />
                                            </div>
                                        </div>

                                        {/* Animator Image Preview */}
                                        <div className="form-group row">
                                            <label
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                            </label>
                                            <div className="col-sm-9 d-flex justify-content-center">
                                                <a href={AnimatorImgPreview} target="_blank" rel="noopener">
                                                    <img
                                                        src={AnimatorImgPreview}
                                                        style={{
                                                            width: "150px",
                                                            maxHeight: "150px",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </a>

                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="submit"
                                                    className="btn d-inline-block btn-primary"
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddAnimator;
